const SITE_URL = "https://urbanbrew.in";
const SITE_NAME = "Urban Brew";
const DEFAULT_OG_IMAGE = `${SITE_URL}/UrbanBrew_Logo_Blue.png`;

const ROUTE_SEO = {
  "/": {
    title: "Urban Brew — Beyond Beverages",
    description:
      "Urban Brew delivers premium workplace refreshment solutions — bean-to-cup coffee, smart vending, and SLA-driven service across India.",
  },
  "/solutions/brew-better": {
    title: "Brew Better — Workplace Coffee Solutions | Urban Brew",
    description:
      "Elevate workplace breaks with bean-to-cup quality, premium blends, and reliable service from Urban Brew.",
  },
  "/solutions/serve-smarter": {
    title: "Serve Smarter — Smart Vending & Refills | Urban Brew",
    description:
      "Seamless vending, smart refills, and SLA-driven service for reliable workplace refreshment.",
  },
  "/solutions/self-serve": {
    title: "Self-Serve Refreshment Solutions | Urban Brew",
    description:
      "Deploy self-serve workplace refreshment with 24×7 access, refills, and end-to-end Urban Brew support.",
  },
  "/solutions/bean-to-cup": {
    title: "Bean-to-Cup Coffee Machines | Urban Brew",
    description:
      "Premium café-style bean-to-cup machines for workplaces, receptions, and hospitality zones.",
  },
  "/solutions/instant-machines": {
    title: "Instant Beverage Machines | Urban Brew",
    description:
      "Fast, consistent instant beverage machines for high-traffic workplaces and institutions.",
  },
  "/solutions/SnackBeverageVending": {
    title: "Snacks & Beverage Vending | Urban Brew",
    description:
      "Multi-category snack and beverage vending solutions with cashless payments and managed service.",
  },
  "/solutions/BeverageEssentials": {
    title: "Beverage Essentials | Urban Brew",
    description:
      "Tea, coffee, and pantry essentials supply for workplaces — quality, consistency, and convenience.",
  },
  "/solutions/smart-tray": {
    title: "Smart Tray Solutions | Urban Brew",
    description:
      "Smart tray refreshment systems for modern workplaces with automated replenishment.",
  },
  "/solutions/refill-subscriptions": {
    title: "Refill Subscriptions | Urban Brew",
    description:
      "Scheduled refill subscriptions to keep your workplace refreshment stations stocked.",
  },
  "/articles": {
    title: "Workplace Insights & Articles | Urban Brew",
    description:
      "Honest, practical articles on workplace refreshments, productivity, and visitor experience.",
  },
  "/contact": {
    title: "Contact Urban Brew",
    description:
      "Get in touch with Urban Brew for support, sales enquiries, accounts, and partnerships.",
  },
  "/careers": {
    title: "Careers at Urban Brew",
    description:
      "Join Urban Brew and help deliver premium workplace refreshment experiences across India.",
  },
  "/tools/estimator": {
    title: "Solution Estimator | Urban Brew",
    description:
      "Estimate the best Urban Brew refreshment setup for your team size and workplace needs.",
  },
  "/tools/onboarding": {
    title: "Get Started — Onboarding | Urban Brew",
    description:
      "Tell us about your workplace and get a tailored Urban Brew refreshment recommendation.",
  },
  "/tools/sla": {
    title: "SLA Selector | Urban Brew",
    description:
      "Choose the service level agreement that best suits your operational refreshment needs.",
  },
  "/tools/advisor": {
    title: "Machine Advisor | Urban Brew",
    description:
      "Answer a few questions and our advisor will recommend the right Urban Brew machine.",
  },
  "/privacy": {
    title: "Privacy Policy | Urban Brew",
    description:
      "How Urban Brew collects, uses, protects, and processes your data when you use our website and services.",
  },
  "/terms": {
    title: "Terms of Use | Urban Brew",
    description:
      "Terms and conditions governing use of the Urban Brew website and services.",
  },
  "/cookies": {
    title: "Cookies Policy | Urban Brew",
    description:
      "How Urban Brew uses cookies and similar technologies on our website.",
  },
  "/legal/privacy-policy": {
    title: "Privacy Policy | Urban Brew",
    description:
      "How Urban Brew collects, uses, protects, and processes your data when you use our website and services.",
    canonicalPath: "/privacy",
  },
  "/legal/terms-and-conditions": {
    title: "Terms of Use | Urban Brew",
    description:
      "Terms and conditions governing use of the Urban Brew website and services.",
    canonicalPath: "/terms",
  },
  "/legal/cookies-policy": {
    title: "Cookies Policy | Urban Brew",
    description:
      "How Urban Brew uses cookies and similar technologies on our website.",
    canonicalPath: "/cookies",
  },
};

export function getSeoForPath(pathname) {
  const fallback = {
    title: `${SITE_NAME} — Beyond Beverages`,
    description:
      "Urban Brew delivers premium workplace refreshment solutions — bean-to-cup coffee, smart vending, and SLA-driven service across India.",
    canonicalPath: pathname,
    ogImage: DEFAULT_OG_IMAGE,
    ogType: "website",
  };

  if (ROUTE_SEO[pathname]) {
    const entry = ROUTE_SEO[pathname];
    return {
      ...fallback,
      ...entry,
      canonicalPath: entry.canonicalPath || pathname,
    };
  }

  const articleMatch = pathname.match(/^\/articles\/([^/]+)$/);
  if (articleMatch) {
    return {
      ...fallback,
      title: "Workplace Insights | Urban Brew",
      description:
        "Read Urban Brew insights on workplace refreshments, culture, and productivity.",
      canonicalPath: pathname,
      ogType: "article",
    };
  }

  return {
    ...fallback,
    title: "Page Not Found | Urban Brew",
    description: "The page you are looking for could not be found on Urban Brew.",
    canonicalPath: pathname,
  };
}

export function getArticleSeo(article) {
  if (!article) return getSeoForPath("/articles");

  return {
    title: `${article.title} | Urban Brew`,
    description: article.summary,
    canonicalPath: `/articles/${article.slug}`,
    ogImage: article.image ? `${SITE_URL}${article.image}` : DEFAULT_OG_IMAGE,
    ogType: "article",
  };
}

export { SITE_URL, SITE_NAME, DEFAULT_OG_IMAGE };
